module.exports = __webpack_public_path__ + "img/logo6.d1b00098.png";